import { Component } from '@angular/core';
import { Skeleton, Alert } from 'excellence-ui';

@Component({
  selector: 'app-dashboard-assistant-card-skeleton',
  imports: [Skeleton, Alert],
  templateUrl: './dashboard-assistant-card-skeleton.html',
})
export class DashboardAssistantCardSkeleton {}
